import config from '../config';
import http from '../utils/http';
import {
    User,
    ActiveUser,
    InvitedUser,
    USER_ACCESS_TYPES,
    USER_STATUS
} from '../interface/user.interface';

const { api } = config;

/**
 * Get all users in current tenant, regardless of status.
 */
export const fetchUsers = async (): Promise<User[]> => {
    const url = api.endpoints.users;
    const response = await http.get(url);
    return response.data.map((u) => parseUserData(u));
};

/**
 * Get all ACTIVE users in current tenant.
 */
export const fetchActiveUsers = async (): Promise<ActiveUser[]> => {
    const allUsers = await fetchUsers();
    return allUsers.filter(
        (user) => user.status === USER_STATUS.ACTIVE
    ) as ActiveUser[];
};

/**
 * Get all INVITED users in current tenant.
 */
export const fetchInvitedUsers = async (): Promise<InvitedUser[]> => {
    const allUsers = await fetchUsers();
    return allUsers.filter(
        (user) => user.status === USER_STATUS.INVITED
    ) as InvitedUser[];
};

/*
 * Converts a user row from the database to a User.
 */
export const parseUserData = (u: any): User => {
    console.log('u.InvitationCode:', u.InvitationCode);
    return {
        id: u.UserID || -1,
        email: u.Email || '',
        profilePicture: u.ProfilePictureURL || '',
        lastName: u.LastName || '',
        firstName: u.FirstName || '',
        company: u.Company || '',
        accessType: u.AccessType || USER_ACCESS_TYPES.DEFAULT,
        jobTitle: u.JobTitle || '',
        accountUrl: '',
        createdDate: u.CreatedDate,
        status: u.InvitationCode?.length
            ? USER_STATUS.INVITED
            : USER_STATUS.ACTIVE
    } as User;
};

/**
 * Delete users.
 *
 * @return {Object}
 */
export async function deleteUser(userId) {
    const url = `${api.endpoints.users}/${userId}`;
    const response = await http.delete(url);

    return response;
}

/**
 * Set default tenant.
 *
 * @return {Object}
 */
export async function updateRole(userId, data) {
    const url = `${api.endpoints.users}/${userId}/accessType`;

    const response = await http.put(url, data);

    return response;
}

/**
 * Invite users.
 *
 * @return {Object}
 */
export async function inviteUser(data) {
    const url = api.endpoints.invitation;
    const response = await http.post(url, data);

    return response;
}

/**
 * Trigger reminder email to the invited user
 */
export async function sendReminderOfInvitation(
    userId: number,
    inviterName: string
): Promise<boolean> {
    const url = api.endpoints.invitation + '/re-invite';
    const response = await http.post(url, { userId, inviterName });

    if (response.status === 200) return true;
    return false;
}
